import { attr, hasMany, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'
import placeholder from '../assets/placeholder_elementary.png'

const Package = ApplicationRecord.extend({
  static: {
    jsonapiType: 'packages',
  },
  attrs: {
    name: attr(),
    imageUrl: attr(),
    bannerUrl: attr(),
    campaign: attr(),
    season: attr(),
    slug: attr(),
    shouldShowAppointments: attr(),
    hasLimitedPoses: attr(),
    defaultBackgroundUrl: attr(),
    isSeniorPortraits: attr(),
    isSitting: attr(),
    multiple: attr(),
    multipleSeasons: attr(),
    placeholder: attr(),
    useNewPackageBuilder: attr(),
    category: attr(),
    softcoverYearbook: attr(),
    hardcoverYearbook: attr(),
    options: hasMany(),
    orderPackage: hasMany(),
    backgroundSet: belongsTo(),
    backgrounds: hasMany(),
    schools: hasMany(),
    packagePoses: hasMany(),
    schoolIds: attr(),
    displaySharedPoses: attr(),
    skipPastImages: attr(),
    hideCss: attr(),
  },
  methods: {
    isYearbook: function () {
      return this.name && this.name.toLowerCase().includes('yearbook')
    },
    placeholderImage: function() {
      if (!this.placeholder.includes('placeholder.png')) return this.placeholder

      return placeholder
    },
  },
})

export default Package
